const $$splitComponentImporter = () => import('/app/frontend/src/routes/_app/user/account/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_app/user/account/')({
  staticData: {
    breadCrumb: 'Account'
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});